import { render, staticRenderFns } from "./SupervisorList.vue?vue&type=template&id=919a891e"
import script from "./SupervisorList.vue?vue&type=script&lang=js"
export * from "./SupervisorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports